import { render, staticRenderFns } from "./Exhibition.vue?vue&type=template&id=b8352180&scoped=true"
import script from "./Exhibition.vue?vue&type=script&lang=js"
export * from "./Exhibition.vue?vue&type=script&lang=js"
import style0 from "./Exhibition.vue?vue&type=style&index=0&id=b8352180&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8352180",
  null
  
)

export default component.exports